/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandPlantAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19.503 7.698C18.391 9.15 16.614 10.273 14 10.501V12h-2v-1.49c-2.363-.163-4.024-.908-5.146-1.905-1.261-1.121-1.757-2.488-1.85-3.466l-.07-.754.706-.272c2.873-1.11 5.259-.16 6.782.974a3.246 3.246 0 0 1 1.235-1.363C15.102 2.846 17.368 2 19.99 2h.937l.06.935c.085 1.297-.27 3.181-1.483 4.763zm-4.807-2.265C14.274 5.69 14 6.24 14 7v1.492c1.988-.213 3.19-1.062 3.916-2.01a5.408 5.408 0 0 0 1.022-2.428c-1.758.18-3.259.782-4.242 1.38zM12 7.373c-.874-.94-2.61-2.103-4.805-1.643.176.437.483.931.988 1.38.716.637 1.896 1.239 3.817 1.395z" />
        <path d="M11 12a1 1 0 0 0-.447.105L6.763 14H2v8h4.847a22.45 22.45 0 0 0 1.957.481c1.298.26 3.115.519 5.196.519v-1l.001 1h.026l.051-.001a7.344 7.344 0 0 0 .74-.072 9.795 9.795 0 0 0 1.899-.487c1.526-.555 3.448-1.66 5.083-3.84A1 1 0 0 0 21 17h-4.843c.273-.324.505-.66.7-.986a9.78 9.78 0 0 0 1.118-2.791l.004-.017V13.2l.001-.002v-.002L17.004 13l.978.196A1 1 0 0 0 17 12zm-3 3.618L11.236 14h4.398c-.128.31-.29.65-.491.986C14.483 16.084 13.503 17 12 17a1 1 0 1 0 0 2h6.703a8.72 8.72 0 0 1-2.67 1.56 7.795 7.795 0 0 1-1.508.388 5.32 5.32 0 0 1-.512.052h-.017a24.78 24.78 0 0 1-4.8-.48A21.694 21.694 0 0 1 8 20.245zM6 16v4H4v-4z" />
      </g>
    </g>
  </Icon>
);
export { SvgHandPlantAlt as HandPlantAlt };
